import React from "react";
import "./loader.scss";

const Loader = () => (
  <div className="loading">
    <div className="spinner-container">
      {/* Rotating Spinner */}
      <div className="spinner"></div>

      {/* Static Lottie Animation */}
      {/* <Lottie
        animationData={loadingAnimation}
        loop={true}
        style={{ width: 40, height: 40 }}
      /> */}
    </div>
  </div>
);
export default Loader;
